<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <a-select v-model="queryParams.itemCode" show-search disabled>
                <a-select-option v-for="(item) in itemCodeList" :key="item.value">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="规格描述">
              <a-input v-model="queryParams.description" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <a-select v-model="queryParams.alternateBom" disabled >
                <a-select-option v-for="(item) in alternateBomList" :key="item.value">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="清单日期">
              <a-date-picker
                v-model="queryParams.inventoryDate"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="显示">
              <a-select v-model="queryParams.show" allowClear>
                <a-select-option v-for="(item) in showList" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <!-- <a-button @click="handleDevelop" type="primary">全部展开</a-button>
      <a-button @click="handlePackUp" type="primary">全部收起</a-button> -->
      <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:itemInventory:exportDetails']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1700 }"
        >
          <template slot="centralizedPurchasingType" slot-scope="{ record }">
            <span>{{ record.centralizedPurchasingType }}</span>
          </template>
          <template slot="wipSupplyType" slot-scope="{ record }">
            <span>{{ $lookupMeaning(wipSupplyTypeList, record.wipSupplyType) }}</span>
          </template>
          <template slot="ecoUseupType" slot-scope="{ record }">
            <span>{{ $lookupMeaning(ecoSwitchTypeList, record.ecoUseupType) }}</span>
          </template>
          <template slot="description" slot-scope="{ text }">
            <span :title="text" class="line-ellipsis w200">{{ text }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';
import { apiItemInventoryDetailsList, apiMdmItemOrganizationItemFindList } from '@/api/mdm/matter/material-inventory'
import { generateLsTableResData } from '@/utils/util.js';
export default {
  // eslint-disable-next-line
  name: 'material-inventory-detail',
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiItemInventoryDetailsList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        itemCode: undefined,
        description: undefined,
        alternateBom: undefined,
        inventoryDate: undefined,
        show: 3
      },
      // 快码表格数据
      typeList: [],
      tableLoading: false,
      // 表格字段
      columns: [
        {
          title: '组件编码',
          dataIndex: 'itemCode',
          align: 'center',
          fixed: 'left'
        },
        {
          title: '组件规格描述',
          dataIndex: 'description',
          scopedSlots: { customRender: 'description' },
          align: 'center',
          fixed: 'left',
          width: 200
        },
        {
          title: '组件单位',
          dataIndex: 'primaryUomCode',
          align: 'center'
        },
        {
          title: '组件物料类型',
          dataIndex: 'itemType',
          align: 'center',
          width: 150
        },
        {
          title: '组件状态',
          dataIndex: 'itemStatusCode',
          align: 'center'
        },
        {
          title: '集采类型',
          dataIndex: 'centralizedPurchasingType',
          scopedSlots: { customRender: 'centralizedPurchasingType' },
          align: 'center'
        },
        {
          title: '用量',
          dataIndex: 'componentQuantity',
          align: 'center'
        },
        {
          title: '产出率',
          dataIndex: 'componentYieldFactor',
          align: 'center'
        },
        {
          title: '供应类型',
          dataIndex: 'wipSupplyType',
          scopedSlots: { customRender: 'wipSupplyType' },
          align: 'center'
        },
        {
          title: '生效时间',
          dataIndex: 'effectivityDate',
          align: 'center'
        },
        {
          title: '失效时间',
          dataIndex: 'disableDate',
          align: 'center'
        },
        {
          title: 'ECO',
          dataIndex: 'eco',
          align: 'center'
        },
        {
          title: 'ECO切换类型',
          dataIndex: 'ecoUseupType',
          scopedSlots: { customRender: 'ecoUseupType' },
          align: 'center'
        }
      ],
      itemCodeList: [], // 物料编码
      detailId: "",
      alternateBomList: [], // 版本
      // 显示
      showList: [
        {
          key: 1,
          value: "全部"
        },
        {
          key: 2,
          value: "当前"
        },
        {
          key: 3,
          value: "当前及将来"
        }
      ],
      expandedRowKeys: [],
      // centralizedPurchasingTypeList: [], // 集采类型
      wipSupplyTypeList: [], // 供应类型
      ecoSwitchTypeList: [] // ECO切换类型
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.detailId = this.$route.query && this.$route.query.id || null;
    this.queryParams.itemCode = this.$route.query && this.$route.query.itemCode || null;
    this.queryParams.description = this.$route.query && this.$route.query.description || null;
    this.queryParams.alternateBom = this.$route.query && this.$route.query.alternateBom || null;
    this.queryParams.inventoryDate = this.getCurrentData()
    this.getSelectItemCodeList()

    // this.getLookupList('MDM_CENTRALIZED_PURCHASING_TYPE', 'centralizedPurchasingTypeList')
    this.getLookupList('MES_SUPPLY_TYPE', 'wipSupplyTypeList')
    this.getLookupList('MDM_ECO_USE_UP_TYPE', 'ecoSwitchTypeList')
  },
  mounted () {
    this.queryParams.billStructureId = this.detailId
    this.queryParams.inventoryDate = this.$moment(this.queryParams.inventoryDate).format('YYYY-MM-DD HH:mm:ss')
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 清单日期
    getCurrentData () {
      return `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`
    },
    recursiveExpand (arr, tmp) {
      for (let i = 0; i < arr.length; i++) {
        tmp.push(arr[i].id)
        if (arr[i].childList !== null && arr[i].childList !== undefined && arr[i].childList.length > 0) {
          this.recursiveExpand(arr[i].childList, tmp)
        }
      }
      return tmp
    },
    // 全部展开
    handleDevelop () {
      this.recursiveExpand(this.typeList, this.expandedRowKeys)
    },
    // 全部收起
    handlePackUp () {
      this.expandedRowKeys = [];
    },
    moment,
    // 物料编码-下拉框
    getSelectItemCodeList () {
      apiMdmItemOrganizationItemFindList({ organizationId: this.organizationCodeOrigin }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label,
              description: element.description
            }
            list.push(obj)
          });
          this.itemCodeList = list
        }
      })
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('mdm/itemInventory/exportDetails', {
        ...this.queryParams
      }, `物料清单详情_${new Date().getTime()}.xlsx`)
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        itemCode: undefined,
        description: undefined,
        alternateBom: undefined,
        inventoryDate: this.getCurrentData(),
        show: 3
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.itemcode{
  /deep/.ant-form-item-children{
    display: flex;
    align-items: center;
  }
}
</style>
